import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _LENDER_RATE_TYPES_DI, _ROUNDING_FACTOR, _PROPERTY_TAX_LENDER_;

import { getNumber } from '../../utils/general';
export var RATE_TYPE_FACTOR = 2400;
export var APR_MF_DECIDER = 0.02; // if given value is > APR_MF_DECIDER, then it's APR else it;s MF

export var LENDER_RATE_TYPES = {
  APR: 0,
  MF: 1
};
export var LENDER_RATE_TYPES_DISPLAY = (_LENDER_RATE_TYPES_DI = {}, _defineProperty(_LENDER_RATE_TYPES_DI, LENDER_RATE_TYPES.APR, 'APR'), _defineProperty(_LENDER_RATE_TYPES_DI, LENDER_RATE_TYPES.MF, 'MoneyFactor'), _LENDER_RATE_TYPES_DI);
export var ROUNDING_FACTOR = (_ROUNDING_FACTOR = {}, _defineProperty(_ROUNDING_FACTOR, LENDER_RATE_TYPES.APR, 2), _defineProperty(_ROUNDING_FACTOR, LENDER_RATE_TYPES.MF, 7), _ROUNDING_FACTOR);
export var formatValueBasedOnRateType = function formatValueBasedOnRateType(value, rateType) {
  var numValue = getNumber(value);
  return getNumber(numValue.toFixed(ROUNDING_FACTOR[rateType] || 2));
};
export var getAPRMFDisplayValue = function getAPRMFDisplayValue(apr, lenderRateType) {
  var isAPR = lenderRateType === LENDER_RATE_TYPES.APR;
  var aprNew = formatValueBasedOnRateType(apr, lenderRateType);
  return isAPR ? "".concat(aprNew, "%") : aprNew;
};
export var TRADEIN_LEASED_TYPES = {
  TURN_IN: 0,
  TRADE_IN: 1
};
export var LENDER_TIERS = {
  LEASE: '0',
  RETAIL: '1'
};
export var PROPERTY_TAX_LENDER_TYPE = {
  NONE: 0,
  FMCC: 1
};
export var PROPERTY_TAX_LENDER_TYPE_DISPLAY_NAME = (_PROPERTY_TAX_LENDER_ = {}, _defineProperty(_PROPERTY_TAX_LENDER_, PROPERTY_TAX_LENDER_TYPE.NONE, 'None'), _defineProperty(_PROPERTY_TAX_LENDER_, PROPERTY_TAX_LENDER_TYPE.FMCC, 'Ford'), _PROPERTY_TAX_LENDER_);